import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry, map } from 'rxjs/operators';

import { ENPOINT } from '../endpoint';
import { Options } from 'selenium-webdriver/safari';

import { GLOBAL } from '../global';

@Injectable()
export class ConfigService {

  constructor(
    private http: HttpClient,
    
  ) { }
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;

  obtenerConfiguracion(): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.get(this.basePath +
       'config', options);
  }

  obtenerConfiguracionMensaje(nombre): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('nombre', nombre)
    };
    return this.http.get(this.basePath +
       'config/get', options);
  }

  guardarConfiguracion(data): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.post(this.basePath +
       'config', data, options);
  }

  sincronizarSAP(): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.get(this.basePath +
       'config/job/run', options);
  }

  sincronizarFacturas(): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.get(this.basePath +
       'config/revisarFacturasPendientes', options);
  }

  sincronizarFacturasPagadas(): Observable<any> {
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };
    return this.http.get(this.basePath +
       'config/job/pagos', options);
  }

  guardarMensaje(nombre,valor,valor2): Observable<any> {

    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('nombre', nombre)
      .set('valor', valor)
      .set('valor2', valor2)
    };

    return this.http.get(this.basePath + 'config/set', options);
  }

  eliminarMensaje(nombre): Observable<any> {

    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('nombre', nombre)
    };

    return this.http.get(this.basePath + 'config/delete', options);
}

guardarMensajeExtranjero(nombre,valor,valor2): Observable<any> {

  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('nombre', nombre)
    .set('valor', valor)
    .set('valor2', valor2)
  };

  return this.http.get(this.basePath + 'config/set', options);
}

eliminarMensajeExtranjero(nombre): Observable<any> {

  const httpHeaders = new HttpHeaders();
  const options = {
    headers: httpHeaders,
    withCredentials: true,
    params: new HttpParams()
    .set('nombre', nombre)
  };

  return this.http.get(this.basePath + 'config/delete', options);
}
}



// WEBPACK FOOTER //
// ./src/app/services/config/config.service.ts